import * as angular from 'angular';
import * as _ from 'lodash';

import { serviceModule } from '../services/services.module';
import * as controls from './';

const colorPickerModule = 'colorpicker.module'; //angular-bootstrap-colorpicker

export const controlModule = 'wt-controls';
const m = angular.module(controlModule, [
    serviceModule,
    colorPickerModule
]);
for (const key of Object.keys(controls)) {
    if (controls[key].hasOwnProperty('componentId')) {
        const obj = controls[key];
        m.component(obj.componentId, obj);
    }
}